import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 48,
	fill: "none",
	viewBox: "0 0 25 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "#d1ecfe",
		strokeLinecap: "round",
		strokeWidth: 2.472,
		d: "M1.493 1.236C21.705 5.63 26.81 22.802 19.138 42.831"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#d1ecfe",
		strokeLinecap: "round",
		strokeWidth: 2.472,
		d: "m23.49 44.03-6.104.604-.604-6.104"
	})]
});
export default SvgArrow;
